import { faCommentDots, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { NavDropdown } from 'react-bootstrap';
import { useYBugApi } from 'src/context/YBugContext';
import Config from 'src/utils/config';
import { SUPPORT_EMAIL, SUPPORT_URL } from 'src/utils/constants';

const SupportDropdown = () => {
  const YBugApi = useYBugApi();

  const isYBugAvailable = YBugApi && Config.yBugId;

  const handleSupport = () => {
    // If YBug is available, open the feedback form
    if (isYBugAvailable) {
      YBugApi?.open('feedback');
    } else {
      // Otherwise, as an alternative, trigger an email to the support team
      window.location.href = `mailto:${SUPPORT_EMAIL}?subject=Report an Issue`;
    }
  };

  const openDocumentation = () => {
    window.open(SUPPORT_URL, '_blank');
  };

  const actions = [
    {
      icon: faInfoCircle,
      label: 'Help',
      onClick: openDocumentation,
    },
    {
      icon: faCommentDots,
      label: 'Report an Issue',
      onClick: handleSupport,
    },
  ];

  return (
    <NavDropdown
      id='support_dropdown'
      className='support-dropdown'
      title={
        <span data-cy='support-dropdown-toggle'>
          <FontAwesomeIcon icon={faQuestionCircle} className='mr3 text-white' />
        </span>
      }
    >
      {actions.map(action => (
        <NavDropdown.Item
          key={action.label}
          data-cy={`support-${action.label.toLowerCase().replace(/\s+/g, '-')}-item`}
          onClick={action.onClick}
        >
          <FontAwesomeIcon icon={action.icon} className='spacer-right' />
          {action.label}
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  );
};

export default SupportDropdown;
